import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e20ade"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "mを法とした位数", -1))
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { style: {"color":"red","background-color":"#fdd"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" a"),
  /*#__PURE__*/_createElementVNode("sup", null, "i"),
  /*#__PURE__*/_createTextVNode(" mod m の表 ")
], -1))
const _hoisted_5 = { style: {"overflow-x":"auto"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "2",
  rowspan: "2",
  class: "doublecell"
}, null, -1))
const _hoisted_7 = ["colspan"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "doublecell"
}, " 位数 ", -1))
const _hoisted_9 = ["rowspan"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 位数ごとの表 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "doublecell" }, " d "),
  /*#__PURE__*/_createElementVNode("th", { class: "widecell" }, [
    /*#__PURE__*/_createTextVNode(" ord"),
    /*#__PURE__*/_createElementVNode("sub", null, "m"),
    /*#__PURE__*/_createTextVNode("(a) = d となる a ")
  ]),
  /*#__PURE__*/_createElementVNode("th", { class: "doublecell" }, " 個数 "),
  /*#__PURE__*/_createElementVNode("th", { class: "doublecell" }, " φ(d) ")
], -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }

import { ref, shallowRef, triggerRef, computed } from 'vue';
import { gcdiv, euler } from '@/composable/lib.ts';
import FactorStr from '@/components/FactorStr.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderMod',
  setup(__props) {

const inputM = ref('');
const m = ref(0);
const phi = computed( () => euler(m.value));
const minus = ref(false);
const message =  ref('');

class PowerData{
  v: number;
  cls: string;
  constructor(v:number, cls:string){
    this.v = v;
    this.cls = cls;
  }
}
const powerTable = shallowRef(new Array<PowerData[]>(0));
const order = shallowRef(new Array<number>(0));
class DivData{
  d: number;
  a: number[];
  constructor(d:number){
    this.d = d;
    this.a = [];
  }
  get phi(){
    if(this.d < Infinity){
      return euler(this.d);
    }else{
      return 0;
    }
  }
  get count(){
    return this.a.length;
  }
  get list(){
    return this.a.join(', ');
  }
}
const divList = shallowRef(new Array<DivData>(0));

function setM(){
  powerTable.value.splice(0);
  order.value.splice(0);
  divList.value.splice(0);
  
  const m_local = Number(inputM.value);
  if(! Number.isInteger(m_local) || m_local <= 1){
    message.value = '2以上の整数を入力してください。';
    m.value = 0;
    return;
  }

  const phi_local = euler(m_local);
  m.value = m_local;
  message.value = '';
  for(let a=0; a<m_local; a++){
    let x=1;
    let first = true;
    const tmpAr = new Array<PowerData>(0);
    for(let i=0; i<= phi_local; i++){
      let cls = '';
      if(gcdiv(a,m_local) != 1){
	cls = 'nonprime';
      }else if(first){
	if(i > 0 && x == 1){
	  cls = 'unit';
	  first = false;
	  order.value.push(i);
	}else{
	  cls = 'loop';
	}
      }else if(x == 1){
	cls = 'secondunit';
      }
      const obj = new PowerData(x,cls);
      tmpAr.push(obj);
      x = x*a % m_local;
    }
    if(first){
      order.value.push(Infinity);
    }
    powerTable.value.push(tmpAr);
  }
  
  for(let d=1; d<=phi_local; d++){
    if(phi_local % d == 0){
      const obj = new DivData(d);
      for(let a=0; a<m_local; a++){
	if(order.value[a] == d){
	  obj.a.push(a);
	}
      }
      divList.value.push(obj);
    }
  }
  const obj = new DivData(Infinity);
  for(let a=0; a<m_local; a++){
    if(order.value[a] == Infinity){
      obj.a.push(a);
    }
  }
  divList.value.push(obj);
  
  triggerRef(powerTable);
  triggerRef(order);
  triggerRef(divList);
  return;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createTextVNode(" 正整数 m を入力 "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputM).value = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, inputM.value]
        ]),
        _createElementVNode("button", { onClick: setM }, "決定"),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((minus).value = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, minus.value]
        ]),
        _createTextVNode(" -1を強調 "),
        _createElementVNode("div", _hoisted_3, _toDisplayString(message.value), 1)
      ]),
      (m.value > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(m.value) + " = ", 1),
              _createVNode(FactorStr, { n: m.value }, null, 8, ["n"])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" φ(" + _toDisplayString(m.value) + ") = " + _toDisplayString(_unref(phi)) + " = ", 1),
              _createVNode(FactorStr, { n: _unref(phi) }, null, 8, ["n"])
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _hoisted_6,
                  _createElementVNode("th", { colspan: _unref(phi) }, " i ", 8, _hoisted_7),
                  _hoisted_8
                ]),
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(phi), (i) => {
                    return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(i), 1))
                  }), 128))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.value, (a) => {
                  return (_openBlock(), _createElementBlock("tr", { key: a }, [
                    (a == 1)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          rowspan: m.value
                        }, " a ", 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", null, _toDisplayString(a-1), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(phi), (i) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: i,
                        class: _normalizeClass(minus.value && _unref(powerTable)[a-1][i].v == m.value-1 && _unref(powerTable)[a-1][i].cls == 'loop' ? 'minus' : _unref(powerTable)[a-1][i].cls)
                      }, _toDisplayString(minus.value && _unref(powerTable)[a-1][i].v == m.value-1 ? -1 : _unref(powerTable)[a-1][i].v), 3))
                    }), 128)),
                    _createElementVNode("td", {
                      class: _normalizeClass({primitive: _unref(order)[a-1] == _unref(phi)})
                    }, _toDisplayString(_unref(order)[a-1] < Infinity ? _unref(order)[a-1] : ''), 3)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_10,
            _createElementVNode("table", null, [
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(divList), (obj) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: obj.d
                }, [
                  (obj.d < Infinity)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(obj.d), 1))
                    : (_openBlock(), _createElementBlock("th", _hoisted_13, " 未定義 ")),
                  _createElementVNode("td", null, _toDisplayString(obj.list), 1),
                  _createElementVNode("td", null, _toDisplayString(obj.count), 1),
                  (obj.d < Infinity)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(obj.phi), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_15))
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})